module.exports = ":host img {\n  width: 1rem;\n  opacity: .5; }\n"


//////////////////
// WEBPACK FOOTER
// ./libs/atenea-cms/src/current-locale-code/current-locale-code.component.scss
// module id = ./libs/atenea-cms/src/current-locale-code/current-locale-code.component.scss
// module chunks = main